import Fetch from '@/utils/Fetch';
import Helper from '@/utils/helper';
import Constants from '@/utils/constants';
import * as Enums from '@/utils/enums';

const getAttachment = async (id: any) => {
    const res = await Fetch.get({
        url: `/Attachment?id=${id}`,
    });
    if (res.ID) {
        return res;
    } else {
        throw new Error(res.serverMessage || res.message || 'Something went wrong');
    }
};

const getItemAttachments = async (itemID: any, excludeSignatures = true) => {
    const request = await Fetch.get({
      url: `/Attachment/GetItemAttachments?itemID=${itemID}&excludeSignatures=${excludeSignatures}`
    });

    return {data: request.Results, total: request.TotalResults};
};

const searchAttachments = async (params: any) => {
    const request = await Fetch.post({
      url: `/Attachment/GetAttachments`,
      params,
    });

    if (request.Results) {
        return request;
    } else {
        throw new Error(request.serverMessage || request.message || 'Something went wrong');
    }
};

const getSignatures = async (itemID: any) => {
    const request = await Fetch.get({
        url: `/Attachment/GetItemAttachments?itemID=${itemID}&excludeSignatures=false`
      });

      let customerSignature;    
      let technicianSignature;

      if (request && request.TotalResults > 0) {

        let customerSignatures = request.Results.filter((x: any) => x.AttachmentType == Enums.AttachmentType.CustomerSignature);
        if (customerSignatures.length > 1) {
            customerSignatures = Helper.sortObjectArrayOnDate(customerSignatures, "ModifiedDate", true);
            customerSignature = customerSignatures[0];
        } else {
            customerSignature = request.Results.find((x: any) => x.AttachmentType == Enums.AttachmentType.CustomerSignature);
        }
        
        let technicianSignatures = request.Results.filter((x: any) => x.AttachmentType == Enums.AttachmentType.TechnicianSignature);
        if (technicianSignatures.length > 1) {
            technicianSignatures = Helper.sortObjectArrayOnDate(technicianSignatures, "ModifiedDate", true);
            technicianSignature = technicianSignatures[0];
        } else {
            technicianSignature = request.Results.find((x: any) => x.AttachmentType == Enums.AttachmentType.TechnicianSignature);
        }
      }
  
      return {customerSignature, technicianSignature};
};

const getSignaturesCustomerZone = async (customerID: any, tenantID: any, api: any, itemID: any) => {
    const request = await Fetch.get({
        url: `/CustomerZone/GetItemAttachments?itemID=${itemID}&excludeSignatures=false`,
        tenantID: tenantID,
        customerID: customerID,
        apiUrlOverride: api,
    });

    let customerSignature;    
    let technicianSignature;

    if (request && request.TotalResults > 0) {

        let customerSignatures = request.Results.filter((x: any) => x.AttachmentType == Enums.AttachmentType.CustomerSignature);
        if (customerSignatures.length > 1) {
            customerSignatures = Helper.sortObjectArrayOnDate(customerSignatures, "ModifiedDate", true);
            customerSignature = customerSignatures[0];
        } else {
            customerSignature = request.Results.find((x: any) => x.AttachmentType == Enums.AttachmentType.CustomerSignature);
        }
        
        let technicianSignatures = request.Results.filter((x: any) => x.AttachmentType == Enums.AttachmentType.TechnicianSignature);
        if (technicianSignatures.length > 1) {
            technicianSignatures = Helper.sortObjectArrayOnDate(technicianSignatures, "ModifiedDate", true);
            technicianSignature = technicianSignatures[0];
        } else {
            technicianSignature = request.Results.find((x: any) => x.AttachmentType == Enums.AttachmentType.TechnicianSignature);
        } 
    }

    return {customerSignature, technicianSignature};
};

const saveSignature = async (itemID: any, module: any, signature: any, isTechnician = false, toast = null) => {
    let id = Helper.newGuid();
    return await Fetch.post({
      url: '/Attachment',
      params: {
        AttachmentType: isTechnician ? Enums.AttachmentType.TechnicianSignature : Enums.AttachmentType.CustomerSignature,
        Description: isTechnician ? 'Technician Signature' : 'Customer Signature',
        FileName: `${id}.png`,
        FileBase64: signature,
        ItemID: itemID,
        Module: module,
        UserType: Enums.UserType.Employee,
        ContentType: 'image/png',
      },
      toastCtx: toast
    });
};

const saveSignatureCustomerZone = async (customerID: any, tenantID: any, api: any, itemID: any, module: any, signature: any, isTechnician = false, toast = null) => {
    let id = Helper.newGuid();
    return await Fetch.post({
        url: '/CustomerZone/SaveAttachment',
        params: {
            AttachmentType: isTechnician ? Enums.AttachmentType.TechnicianSignature : Enums.AttachmentType.CustomerSignature,
            Description: isTechnician ? 'Technician Signature' : 'Customer Signature',
            FileName: `${id}.png`,
            FileBase64: signature,
            ItemID: itemID,
            Module: module,
            UserType: Enums.UserType.Employee,
            ContentType: 'image/png',
        },
        toastCtx: toast,
        tenantID: tenantID,
        customerID: customerID,
        apiUrlOverride: api,
    });
};

const validateAttachment = async (fileBase64: any, fileUploadSize: any) => {

    let uploadLength = 2;

    if (fileUploadSize.Unit == 'kb') {
        uploadLength = fileBase64.length / 1024;
    } else if (fileUploadSize.Unit == 'mb') {
        uploadLength = fileBase64.length / 1024 / 1024;
    } else if (fileUploadSize.Unit == 'gb') {
        uploadLength = fileBase64.length / 1024 / 1024 / 1024;
    }

    // base64 converts 6bits to 8bits when encoding, so the actual file size is 3/4
    let scalingFactor = Constants.base64BitScalingFactor;
    uploadLength *= scalingFactor;

    if (uploadLength > parseFloat(fileUploadSize.Value)) {
        return false;
    }

    return true;
};

const saveAttachments = async (attachmentType: any, files: any, itemID: any, module: any, toast = null) => {
    return await Fetch.post({
        url: '/Attachment/SaveAttachments',
        params: {
            attachmentType,
            files,
            itemID,
            module,
        },
        toastCtx: toast,
        statusIfNull: true
    });
};

const updateAttachment = async (params: any) => {
    return await Fetch.put({
        url: `/Attachment`,
        params: params,
    })
}

const deleteAttachment = async (id: any) => {
    return await Fetch.destroy({
        url: `/Attachment?id=${id}`,
    });
};

const deleteAttachmentCustomerZone = async (customerID: any, tenantID: any, api: any, id: any) => {
    return await Fetch.destroy({
        url: `/CustomerZone/DeleteAttachment?id=${id}`,
        tenantID: tenantID,
        customerID: customerID,
        apiUrlOverride: api,
    });
};

export default {
    getAttachment,
    searchAttachments,
    getItemAttachments,
    getSignatures,
    getSignaturesCustomerZone,
    saveSignature,
    saveSignatureCustomerZone,
    validateAttachment,
    saveAttachments,
    updateAttachment,
    deleteAttachment,
    deleteAttachmentCustomerZone,
};
